var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCurrentMagentoClient } from "@jti/magento";
export const magentoBaseQuery = (_a) => __awaiter(void 0, [_a], void 0, function* ({ isTrial, method, params, }) {
    var _b;
    try {
        const client = getCurrentMagentoClient(isTrial);
        const methodToCall = client[method];
        if (typeof methodToCall !== "function") {
            throw new Error(`Method '${String(method)}' does not exist on Magento client.`);
        }
        const result = yield methodToCall.call(client, ...params);
        return { data: result };
    }
    catch (error) {
        return {
            error: {
                message: (_b = error.message) !== null && _b !== void 0 ? _b : "An unknown error occurred in Magento API",
            },
        };
    }
});
//# sourceMappingURL=magentoBaseQuery.js.map